export const PORTAL_PLACEMENT_DESCRIPTIONS = [
	'Add a button anywhere on your app or website',
	'Embed portals inline',
	'Add launchers like a command bar or floating button',
	'Trigger manually with JavaScript (basic coding required)',
];
